<h2>Flight selected</h2>
<div class="flights-by-schedule-container">
  <div class="remove-and-search-again">
    <button
      mat-stroked-button
      class="basket_item_action_button"
      i18n-title
      title="Remove & Search again"
      (click)="removeAndSearchAgain.emit(true)"
      (keydown.enter)="removeAndSearchAgain.emit(true)"
    >
      <span aria-hidden="true">
        <i class="ico-trash"></i>
      </span>
      <span i18n="@@RemoveSearchAgain">Remove & Search again</span>
    </button>
  </div>
  <div class="flights-by-schedule-list-container">
    <div class="flights-by-schedule-list">
      @for (item of multiCityByScheduleFlightsList; track item) {
        <div class="flights-by-schedule-item">
          <span class="flight-logo-container">
            <app-image-with-error
              title="{{ item.marketingCarrier + item.marketingFlightNumber }}"
              logoUrl="{{
                'https://images.sabscorp.com/images/TourOp/svg/' + item.marketingCarrier + '.svg'
              }}"
              alt="{{ item.marketingCarrier }} {{ item.marketingFlightNumber }}"
              errorIcon="ico-flight"
              class="ie-width-fix"
            >
            </app-image-with-error>
          </span>
          <span
            >{{ item.marketingCarrier }}{{ item.marketingFlightNumber }}
            {{ item.originAirportName }} ({{ item.originAirport }})
            <time>{{ parseDateToMoment(item.dateTimeDeparting) | sabsTimePipe }} </time>
            {{ item.destinationAirportName }} ({{ item.destinationAirport }})
            <time>{{ parseDateToMoment(item.dateTimeArriving) | sabsTimePipe }}</time>
          </span>
        </div>
      }
    </div>

    @if (flightItinerary) {
      <ng-container *ngTemplateOutlet="flightItineraryExists"></ng-container>
    } @else {
      <div class="price-container">
        <button
          appButton="small"
          (click)="getPrice()"
          (keydown.enter)="getPrice()"
          [disabled]="loadingPrice"
          i18n="@@byScheduleGetPrice"
        >
          Get price
        </button>
      </div>
    }

    @if (requiresReason?.length || unavailable) {
      <app-warning-tags iconId="" [ticket]="getFareRules()" [displayCheck]="false">
      </app-warning-tags>
    }

    <ng-template #flightItineraryExists>
      <div class="price-container">
        <span class="flight-price">
          {{ flightItinerary.total.price }} {{ flightItinerary.total.currency }}
        </span>
        <div class="flight-baggage">
          <b
            >{{ searchParams.getTotalBaggage(flightItinerary) }}
            @if (searchParams.getTotalBaggage(flightItinerary) !== 1) {
              <span>
                <span i18n="@@bags">bags</span>
              </span>
            } @else {
              <span i18n="@@bag">bag</span>
            }
          </b>
        </div>
        <button
          appButton="small"
          (click)="addToBasket()"
          (keydown.enter)="addToBasket()"
          [disabled]="unavailable"
        >
          @if (!displayItinerary) {
            <span i18n="@@byScheduleAddtoBasket">Add to Basket</span>
          }
          @if (displayItinerary) {
            <span i18n="@@byScheduleAddtoItinerary">Add to Itinerary</span>
          }
        </button>
        @if (flightItinerary.co2PerItem) {
          <div class="flight-co2">
            {{ flightItinerary.co2PerItem }} <span i18n="@flight_kg">kg</span>&nbsp;
            <span i18n="@flight_leg_co2">CO</span><sub i18n="@flight_leg_2">2</sub>&nbsp;<span
              i18n="@flight_pp"
              >pp</span
            >
          </div>
        }
      </div>
    </ng-template>
  </div>
</div>
